import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const MenuImageListSwiper = (swiperSelector, slidesPerView, spaceBetween) => {
  return new Swiper(swiperSelector, {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    freeMode: true,
  });
};

export default MenuImageListSwiper;
